@let isExportDisabled = cooldownService.isCooldownActive(seasonId());
@let isExportLoading = isExporting();

<div class="inline-flex flex-col gap-1">
    <div class="relative inline-flex">
        <sh-button
            color="secondary"
            icon="download"
            iconPosition="left"
            [ariaLabel]="'seasons.season-details.buttons.export-applications' | translate"
            [disabled]="isExportDisabled || isExportLoading"
            (click)="exportApplications()"
            [label]="'seasons.season-details.buttons.export-applications' | translate"
            layout="compact"
        />

        @if (isExportLoading) {
            <div
                class="pointer-events-none absolute inset-0 z-20 flex items-center justify-center rounded-md bg-[var(--base-0)]"
            >
                <sh-spinner size="s" />
            </div>
        }
    </div>

    @if (isExportDisabled) {
        <span class="w-0 min-w-full whitespace-normal break-words text-xs text-darkGraySubtitleColor select-none">
            @let time = cooldownService.getRemainingCooldownTimeLabel(seasonId());
            {{ 'seasons.season-details.export-applications-disabled' | translate: { time } }}
        </span>
    }
</div>
